
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.626 3.14h-.414a.622.622 0 00-.622.622v3.512l1.694 1.318c.27.21.661.162.872-.11l.254-.326a.622.622 0 00-.109-.872l-1.054-.82V3.762a.622.622 0 00-.621-.622"}}),_c('g',{attrs:{"clip-path":"url(#clip-C68E5D9D-353C-7893-BA75-442103AC0105)"}},[_c('path',{attrs:{"d":"M15.688 13.763l-3.146-3.146a.757.757 0 00-.536-.221H11.5l-.08.08a6.389 6.389 0 001.424-4.036A6.422 6.422 0 001.985 1.81L.708.53A.414.414 0 000 .823v3.765c0 .229.185.414.414.414H4.18c.37 0 .554-.446.293-.707L3.158 2.98a4.762 4.762 0 018.03 3.472 4.762 4.762 0 01-4.766 4.764 4.746 4.746 0 01-2.96-1.03.623.623 0 00-.826.052l-.292.292a.62.62 0 00.048.922 6.396 6.396 0 004.035 1.422 6.388 6.388 0 004.019-1.424l-.09.09v.505c0 .202.078.395.22.537l3.146 3.146a.754.754 0 001.07 0l.893-.893a.76.76 0 00.003-1.073"}})])])
          )
        }
      }
    